// Helpers
import api from "@/helpers/api";
// Actions
import { endSpinner, startSpinner } from "@/config/store/spinnerReducer";
import { store } from "@/config/store";

type GetDataOptions<T> = {
    displaySpinner?: boolean;
    errorCb?: (error: any) => void;
    fullScreenSpinner?: boolean;
    params?: any;
    sortDataBy?: (a: T, b: T) => number;
    successCb?: (data: T) => void;
    url: string;
};

export const getData = <T>({
    displaySpinner = true,
    errorCb,
    fullScreenSpinner = false,
    params,
    sortDataBy,
    successCb,
    url
}: GetDataOptions<T>): Promise<T> => {
    displaySpinner &&
        store.dispatch(
            startSpinner({
                fullScreen: fullScreenSpinner,
                message: ""
            })
        );

    return api
        .get<T>({ path: url, params })
        .then(response => {
            let data = response.data;
            displaySpinner && store.dispatch(endSpinner());

            if (sortDataBy && Array.isArray(data)) {
                data.sort(sortDataBy);
            }

            successCb && successCb(data);

            return data;
        })
        .catch(err => {
            console.error("Error fetching data:", err);
            displaySpinner && store.dispatch(endSpinner());
            errorCb && errorCb(err);
            return [] as T;
        });
};
